export default "__VITE_ASSET__7d67a4e8__"